module.exports = __webpack_public_path__ + "img/success.fdd754e3.svg";